import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { RESEND_OTP, RESEND_OTP_ERROR, RESEND_OTP_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* resendOTP({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/resend-otp`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: RESEND_OTP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: RESEND_OTP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: RESEND_OTP_ERROR, payload: error });
  }
}

export function* watchResendOTP() {
  yield takeEvery(RESEND_OTP, resendOTP);
}

function* resendOTPSaga() {
  yield all([fork(watchResendOTP)]);
}

export default resendOTPSaga;
